/* unplugin-vue-components disabled */import { render } from "./question-timer.vue?vue&type=template&id=ba9889a8&scoped=true"
import script from "./question-timer.vue?vue&type=script&lang=js"
export * from "./question-timer.vue?vue&type=script&lang=js"

import "./question-timer.vue?vue&type=style&index=0&id=ba9889a8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba9889a8"],['__file',"src/components/chat-input-v2/question/question-timer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba9889a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba9889a8', __exports__)) {
    api.reload('ba9889a8', __exports__)
  }
  
  module.hot.accept("./question-timer.vue?vue&type=template&id=ba9889a8&scoped=true", () => {
    api.rerender('ba9889a8', render)
  })

}


export default __exports__